import { RouterModule, provideRouter } from '@angular/router';
import { NgModule, InjectionToken, APP_INITIALIZER, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { NamedRouter, NamedRoutes } from '@/app/core/services/named-router';

function initializeRoutes(router: NamedRouter, routes: NamedRoutes) {
  return async () => {
    await router.setRoutes(routes);
  };
}

const NAMED_ROUTES_TOKEN = new InjectionToken<NamedRoutes>('NAMED_ROUTES_TOKEN');

@NgModule({
  imports: [RouterModule],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NamedRouterModule {
  public static forRoot(routes: NamedRoutes): ModuleWithProviders<NamedRouterModule> {
    return {
      ngModule: NamedRouterModule,
      providers: [
        NamedRouter,
        provideRouter(routes),
        { provide: NAMED_ROUTES_TOKEN, useValue: routes },
        {
          provide: APP_INITIALIZER,
          useFactory: initializeRoutes,
          deps: [NamedRouter, NAMED_ROUTES_TOKEN],
          multi: true,
        },
      ],
    };
  }
}
